import { getConciliationAccountDisplayNumber } from '../../../../../../utils/conciliationAccountDisplay'
import clsx from 'clsx'
import { Text } from '../../../../../ui'
import { useEffect, useMemo, useState } from 'react'
import { formatDate, formatCurrency } from '../../../../../../utils/formatter'
//import CustomPagination from '../../../../../table/CustomPagination'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
//import { colsTableArriendo as cols } from '../../../../../data/headersTables'
import { bankIcons } from '../../../../../views/dashboard/Administracion/bancos/data'
import imgDefaultBank from '../../../../../../../assets/iconos/iconCasa.png'
import DoneAllIcon from '@mui/icons-material/DoneAll'

const TableMovVincular = ({
  onCheckboxChange,
  rows,
  dataLinkage,
  serverLinkage,
  onCurrentSelectedIdsChange,
  onCurrentData,
  onSort,
  order,
  modalStatus,
  selectedIds,
  setSelectedIds,
  setUnselectedIds,
  selectedCheckboxes,
  setSelectedCheckboxes,

}) => {
 // --- Nuevo código fusionado ---

const [isInitialSelectionDone, setIsInitialSelectionDone] = useState(false)
const [processedRows, setProcessedRows] = useState([])

const getRowKey = row => {
  const raw = row?.idPrincipal ?? row?.id
  return raw != null ? String(raw) : null
}

const getRowDate = row => row?.fecha || row?.fechaPago
const getLinkedDate = item => {
  const linked = (Array.isArray(serverLinkage) ? serverLinkage : dataLinkage ?? [])
    .find(row => getRowKey(row) === getRowKey(item))
  return linked ? linked.fechaRelacionada : getRowDate(item)
}
const getBankName = row => row?.nombreCuentaBanco || row?.name || ''

const serverLinkedKeySet = useMemo(() => {
  const linkage = Array.isArray(serverLinkage)
    ? serverLinkage
    : []

  return new Set(
    linkage
      .filter(item => getBankName(item) !== 'Caja Principal')
      .map(item => getRowKey(item))
      .filter(key => key != null)
  )
}, [serverLinkage])

const getRowAmount = row => {
  if (Number(row?.tabla) === 46) {
    return -Math.abs(Number(row?.monto) || 0)
  }
  const isCargo = row?.tipoMovimiento === 'cargo' ||
    Number(row?.tablaPrincipal ?? row?.origenTabla) === 7 || Number(row?.montoCargo) > 0
  const originalAmount = row?.montoTotal ?? (isCargo ? row?.montoCargo : row?.montoAbono)
  if (originalAmount != null && Number.isFinite(Number(originalAmount))) {
    return (isCargo ? -1 : 1) * Math.abs(Number(originalAmount))
  }
  return Number(row?.amount) || 0
}


const handleCheckboxToggle = rowKey => {
  if (rowKey == null) return
  const targetRow = processedRows.find(r => getRowKey(r) === rowKey)
  const normalizedKey = targetRow?.idPrincipal ?? targetRow?.id ?? rowKey
  const normalizedString = String(normalizedKey)

  const currentIds = Array.isArray(selectedIds) ? selectedIds : []
  const willSelect = !currentIds.some(val => String(val) === normalizedString)

  const nextIds = willSelect
    ? [...currentIds, normalizedKey]
    : currentIds.filter(val => String(val) !== normalizedString)

  setSelectedIds(nextIds)
  onCheckboxChange?.('banco', nextIds)
  onCurrentSelectedIdsChange?.(nextIds)

  const selectedRows = processedRows.filter(r =>
    nextIds.some(val => String(val) === String(r.id) || String(val) === String(r.idPrincipal))
  )
  onCurrentData?.(selectedRows)

  setSelectedCheckboxes(prev => {
    const map = prev || {}
    const next = { ...map }
    if (willSelect) {
      next[rowKey] = true
    } else {
      delete next[rowKey]
    }
    return next
  })

  setUnselectedIds(prev => {
    const current = Array.isArray(prev) ? prev : []
    const targetKey = String(normalizedString)

    if (willSelect) {
      return current.filter(
        value => String(value) !== targetKey
      )
    }

    // Sólo se desvincula en Luca si realmente estaba
    // persistido en el linkage nativo.
    if (!serverLinkedKeySet.has(targetKey)) {
      return current
    }

    const exists = current.some(
      value => String(value) === targetKey
    )

    if (exists) return current

    return [
      ...current,
      normalizedKey
    ]
  })
}


// Construcción de linkageRows (igual que antes)
const linkageRows = Array.isArray(dataLinkage)
  ? dataLinkage
      .filter(item => getBankName(item) !== 'Caja Principal')
      .map((item) => ({
        ...item,
        id: item.id,
        idPrincipal: item.idPrincipal,
        fecha: getLinkedDate(item),
        fechaPago: undefined,
        nombreCuentaBanco: getBankName(item),
        numeroCuentaBanco: item.numeroCuentaBanco,
        descripcion: item.descripcion,
        amount: getRowAmount(item),
        seleccionado: true,
        isLinkage: true,
      }))
  : [];

  const baseRows = useMemo(() => {
    const safeRows = Array.isArray(rows) ? rows : []
    const mapByKey = new Map()
    linkageRows.forEach(lr => {
      const key = getRowKey(lr)
      if (key == null) return
      mapByKey.set(key, { ...lr, seleccionado: true })
    })
    safeRows.forEach(row => {
      const key = getRowKey(row)
      if (key == null) {
        const tmpKey = Symbol()
        mapByKey.set(tmpKey, row)
      } else if (!mapByKey.has(key)) {
        mapByKey.set(key, row)
      } else {
        const existing = mapByKey.get(key)
        mapByKey.set(key, { ...existing, ...row, fecha: existing.fecha, fechaPago: undefined,
          seleccionado: existing.seleccionado || row.seleccionado })
      }
    })
    const combined = Array.from(mapByKey.values())
    .filter(row => getBankName(row) !== 'Caja Principal')
    return combined
  }, [rows, dataLinkage, serverLinkage])

// Guardamos las filas procesadas y selección inicial (una sola vez por cambio real de data)
useEffect(() => {
  setProcessedRows(baseRows)
  if (isInitialSelectionDone) return
  const initialSelection = {}
  const isConciliado =
    ['COBRADO', 'PAGADO', 'PARCIALMENTE COBRADO', 'PARCIALMENTE PAGADO'].includes(modalStatus)

  baseRows.forEach(item => {
    const key = getRowKey(item)
    if (key == null) return
    const shouldSelect =
      (isConciliado && item.seleccionado === true) || item.isLinkage

    if (shouldSelect) {
      initialSelection[key] = true
    }
  })

  setSelectedCheckboxes(prev => ({
    ...(prev || {}),
    ...initialSelection
  }))
  setIsInitialSelectionDone(true)

  const selectedData = baseRows.filter(r => {
    const key = getRowKey(r)
    return key != null && initialSelection[key]
  })
  const initialIds = selectedData
    .map(item => item?.idPrincipal ?? item?.id)
    .filter(id => id !== null && id !== undefined)

  setSelectedIds?.(initialIds)
  onCheckboxChange?.('banco', initialIds)
  onCurrentSelectedIdsChange?.(selectedData.map(r => r.idPrincipal))
  onCurrentData?.(selectedData)
}, [baseRows, modalStatus, isInitialSelectionDone, setSelectedIds, onCheckboxChange])

// Si cambia completamente la data, permitir nueva inicialización
useEffect(() => {
  setIsInitialSelectionDone(false)
  setSelectedCheckboxes({})
  setProcessedRows([])
}, [dataLinkage?.length, rows?.length, modalStatus])

  const styles = {
    wrapper: 'overflow-x-auto rounded-3xl shadow-sm',
    table: 'w-full table-auto text-[0.725rem] border-collapse leading-tight',
    thead: 'sticky top-0 z-10 bg-gray-50',
    th: 'py-2 px-1 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.65rem]',
    text: 'text-[0.705rem] text-gray-400 font-medium',
  }

  const orderableCols = [
    { col: '', field: null },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Cuenta Corriente', field: 'cuentaCorriente' },
    { col: 'Descripción', field: 'descripcion' },
    { col: 'Abono', field: 'abono' },
    { col: 'Cargo', field: 'cargo' },
    { col: 'Disponible', field: 'auxiliar' },
    /*{ col: 'Status', field: 'status' },*/
    { col: 'Acciones', field: null }
  ]

  const truncateText = (text, max = 15) => {
    if (!text) return ''
    return text.length > max ? text.slice(0, max) + '...' : text
  }

  return (
    <div className={styles.wrapper}>
      <div className='mt-2 font-medium'>
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              {orderableCols.map(({ col, field }, i) => (
                <th
                  className={clsx(
                    styles.th,
                    { 'cursor-pointer': field },
                    i === 0 && styles.mediumCol
                  )}
                  onClick={() => field && onSort({ col, field })}
                  key={i}
                >
                  {col}
                  {order.col === col && (
                    <KeyboardArrowDownIcon
                      className={clsx('transition-all ml-2 cursor-pointer', {
                        'opacity-40': order.col !== col,
                        'rotate-180': order.direction === 'desc'
                      })}
                    />
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={styles.tbody}>
            {baseRows.filter(row => getBankName(row) !== "Caja Principal")
            .map((item, i) => {
              const rowKey = getRowKey(item) ?? `row-${i}`
              const isChecked = !!selectedCheckboxes[rowKey]
              const bankName = getBankName(item)
              const amount = getRowAmount(item)
              return (
                <tr key={rowKey} className={clsx(styles.tr, item.isLinkage)}>
                  <td className={clsx(styles.td, styles.mediumCol)}>
                    <div className='flex items-center gap-2'>
                      <input
                        type='checkbox'
                        className='rounded'
                        checked={isChecked}
                        onChange={() => handleCheckboxToggle(rowKey)}
                      />
                      <img
                        src={bankIcons[bankName] || imgDefaultBank}
                        className='min-w-8 h-8'
                      />
                    </div>
                  </td>
                  <td className={clsx(styles.td, styles.mediumCol)}>
                    <Text className={styles.boldText}>{formatDate(getRowDate(item))}</Text>
                  </td>
                  <td className={clsx(styles.td, styles.mediumCol)}>
                    <Text className={styles.boldText}>{bankName}</Text>
                    <Text className={styles.text}>{getConciliationAccountDisplayNumber(item, item.numeroCuentaBanco)}</Text>
                  </td>
                  <td className={clsx(styles.td, styles.wideCol)}>
                    <Text className={clsx(styles.boldText, 'truncate')}  title={item.descripcion}>{truncateText(item.descripcion)}</Text>
                  </td>
                  <td className={clsx(styles.td, styles.mediumCol)}>
                    <Text className={styles.boldText}>
                      {amount > 0 ? amount.toLocaleString('es-CL') : 0}
                    </Text>
                  </td>
                  <td className={clsx(styles.td, styles.mediumCol)}>
                    <Text className={styles.boldText}>
                      {amount < 0 ? Math.abs(amount).toLocaleString('es-CL') : 0}
                    </Text>
                  </td>
                  <td className={clsx(styles.td, styles.mediumCol)}>
                    <Text className={styles.boldText}>{formatCurrency(item.auxiliar)}</Text>
                  </td>

                  <td className={clsx(styles.td, styles.mediumCol)}>
                    <div className='flex h-full items-center justify-center space-x-3'>
                      <div className='flex flex-col text-xs text-gray-500 items-center justify-center hover:cursor-pointer'>
                        <button
                          className={clsx(
                            'flex items-center justify-center w-7 h-7 rounded-full shadow-full-xs transition-colors duration-150',
                            {
                              'bg-accent2 text-white hover:bg-accent2/90 cursor-pointer': isChecked,
                              'bg-gray-100 text-gray-300 hover:bg-gray-200 cursor-pointer':
                                !isChecked
                            }
                          )}
                          onClick={() => handleCheckboxToggle(rowKey)}
                        >
                          <DoneAllIcon className='w-4 h-4' />
                        </button>
                        <Text className='mt-2'>{isChecked ? 'Seleccionado' : 'Seleccionar'}</Text>
                      </div>
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TableMovVincular
